
const { EventEmitter } = require('events');

const deprecate = require('util-deprecate');

const _ = require('lodash');
const $ = require('jquery');
require('rgs-jquery-fileupload');
const ko = require('knockout');
const Serializable = require('serializable');

function File (js) {
	var self = Serializable({
		ID: ko.observable(),
		Name: ko.observable(),
		Size: ko.observable(),
		HumanReadableSize: ko.pureComputed(function () {
			const b = self.Size();
			let kb = b / 1024,
				mb = kb / 1024;
			return mb >= 1
					? mb.toFixed(2) + ' МБ'
					: kb >= 1
					? kb.toFixed(2) + ' КБ'
					: b + ' Б';
		}),
		State: ko.oneOf(['initial', 'uploading', 'uploaded', 'failed']),
	});

	self.fromJS(js);

	return self;
}

const fileuploader = deprecate(function (fullNameControl, options) {
	function newTag (i){
		return (i || 0) + '__complaintsFileUpload_' + Math.random();
	}

	function findFileModelByFileuploadFile (f) {
		return _.find(options._filesData(), function (fModel) {
			return fModel[f.tag] === f;
		});
	}

	$('.' + fullNameControl).fileupload({
		url: '/api/file/SaveTemporaryFile',
		forceIframeTransport: true,
		dataType: 'json',
		formAcceptCharset: 'utf-8',
		change: function (e, data) {
			data.files.length = Math.max(0, Math.min(
					data.files.length,
					options._params.fileOptions.maxNumberOfFiles - options._filesData().length
			));
			_.map(data.files, function (f, i) {
				const tag = newTag(i);
				const fModel = new options._params.fileModel({
					Name: f.name,
					Size: f.size,
				});
				f['tag'] = tag;
				fModel[tag] = f;

				options._filesData.push(fModel);
			});
		},
		submit: function (e, data) {
			data.formData = {}; // Do not send the whole form, only files

			const filesNotToBeSubmitted = [];

			_.map(data.files, function (f) {
				const fModel = findFileModelByFileuploadFile(f);
				if (f.size > options._params.fileOptions.maxFileSize) {
					fModel.State('failed');
					options._filesData.isModified(true);
					filesNotToBeSubmitted.push(f);
				} else {
					fModel.State('uploading');
				}
			});

			_.map(filesNotToBeSubmitted, function (f) {
				data.files.splice(data.files.indexOf(f), 1);
			});

			// If this callback returns false, the file upload request is not started
			return Boolean(data.files.length);
		},
		done: function (e, data) {
			_.map(data.files, function (f) {
				const res = data.response().result;
				const ok = res && res.Status === 'Success';
				const fModel = findFileModelByFileuploadFile(f);
				if (!fModel)					{
					return;
				}

				if (ok) {
					fModel.ID(
						_.findKey(res.Data, function (v) {
							return v.Name.replace(/^.*\\|\//g, '') === fModel.Name()
							   && (fModel.Size() === undefined || v.Size === fModel.Size());
						})
					);
				}
				fModel.State(ok ? 'uploaded' : 'failed');
			});
		},
		fail: function (e, data) {
			_.map(data.files, function (f) {
				findFileModelByFileuploadFile(f)
						.State('failed');
			});
		},
	});
}, '"file-upload" component is deprecated, please use "file-upload2" instead');

module.exports = class FileInputModel {
	constructor (params) {
		const self = this;
		const mode = this._mode = ko.oneOf([
			'select',
			'information',
			'both',
		]);
		// ko.tasks.runEarly();
		// params = _.defaultsDeep({}, params, {
		// 	fileOptions:{
		// 		inputName: 'file-upload-hide',
		// 		isFake:false,
		// 		maxFileSize: Infinity,
		// 		maxNumberOfFiles: 1,
		// 		domReady: ko.observable(false)
		// 	},
		// 	fileModel: File
		// });

		params.fileOptions = _.extend({
			inputName: 'file-upload-hide',
			isFake: false,
			maxFileSize: Infinity,
			maxNumberOfFiles: 1,
			domReady: ko.observable(false),
		}, params.fileOptions);

		params.fileModel = _.extend(File, params.fileModel);

		const __params = this._params = params;

		// Observables for each name
		const filesData = this._filesData = params.filesData.value;



		ko.computed(function (){
			if (__params.fileOptions.maxNumberOfFiles > 1) {
				mode('both');
				return;
			}
			mode(filesData().length > 0 ? 'information' : 'select');
		});

		ko.computed(function (){
			if (!__params.fileOptions.domReady() || __params.fileOptions.isFake)				{
				return;
			}

			setTimeout(function (){
				fileuploader(__params.fileOptions.inputName, self);
			}, 100);
		});
		_.extend(self, _.pick(_.bindAll(new EventEmitter()), 'on', 'emit'));

		self.on('_selectFile', function (){
			//$('.' + __params.fileOptions.inputName).click();
		});

		self.on('_removeSelectedFile', function (data){
			self._filesData.remove(data);
		});
	}
};

